export default "__VITE_ASSET__DVW1JDGI__"